import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';

export class BranchRepository
{
    static create()
    {
        backdrop.show('Creating Branch...Please wait!');
        let form = $('#create-branch-form');
        let formData = form.serialize();

        let success = function(response) {
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title,
            });
            if (response.type === 'success') {
                form.find('input').val('');
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        };
        let errorMessage = 'Failed to create organisation. Please check your connection and try again or contact your System Administrator';

        new ApiCalls(formData, form.attr('action'), success, errorMessage).dispatch();
    }
}
